<template>
  <tr>
    <td @click="toggleSelected">
      <input
        :id="`submission-${submission.id}`"
        :checked="selected"
        type="checkbox"
        :name="`submission-${submission.id}`"
      >
      <label
        :for="`submission-${submission.id}`"
        class="checkbox pb-2"
        style="padding-left: 0 !important;"
      />
    </td>
    <td>
      <div
        class="tag"
        v-html="submitterName"
      />
    </td>
    <td>
      <div
        class="tag"
        v-text="submittedAt || 'n/a'"
      />
    </td>
    <td>
      <a
        href="#"
        @click.prevent="viewSubmissionModal"
        v-text="'View Submission'"
      />
    </td>
    <FormSubmissionDetailModal
      :show="showSubmissionModal"
      :submission="submission"
      @close="hideSubmissionModal"
    />
  </tr>
</template>

<script type="text/babel">
import FormSubmissionDetailModal from './FormSubmissionDetailsModal'

export default {
  name: 'FormSubmissionRow',
  components: {
    FormSubmissionDetailModal,
  },
  props: {
    submission: {
      type: Object,
      required: true,
    },
  },
  data(){
    return {
      showSubmissionModal: false,
    }
  },
  computed: {
    submitterName() {
      return this.submission.submitter.attributes.full_name
    },
    submittedAt() {
      return this.submission.attributes.submitted_at_diff
    },
    selected(){
      return Boolean(this.$store.state.form.selectedSubmissions.find(element => element.id === this.submission.id))
    },
  },
  methods: {
    viewSubmissionModal() {
      this.showSubmissionModal = true
    },
    hideSubmissionModal() {
      this.showSubmissionModal = false
    },
    toggleSelected() {
      this.selected
        ? this.$store.commit('formRemoveSelectedFormSubmission', this.submission)
        : this.$store.commit('formAddSelectedFormSubmission', this.submission)
    },
  },
}
</script>
